import Auth from './Auth';
import User from './User';
import Assets from './Assets';
import Artists from './Artists';
import Auctions from './Auctions';

export default {
  namespaced: true,
  modules: {
    Auth,
    User,
    Artists,
    Assets,
    Auctions,
  },
  state: {},
  actions: {},
  mutations: {},
  getters: {},
};
